// Layout-vakiot: kiinteät mitat, jotka eivät ole spacing-tokeneita.
// Kommentoitu erikseen, koska CLAUDE.md kieltää pikselikovakoodauksen
// styled-componentseissa — nämä ovat poikkeus, koska ne ovat sovelluskohtaisia
// layout-mittoja (ei DS:n perusspacingia).
//
// Kohdenäyttö 1920×1080 (ammattilaisportaali, työasema).
// Yläpalkki on poistettu — sovelluksen ainoa kromi on sivupalkki, joka on
// kiinni ikkunan vasemmassa, ylä- ja alareunassa. Oikealla on 25px gap
// (l-token) sisältöön.
// Layout-summa 1920px:n näytölle:
//   240 (SideNav)
// + 25  (gap sivupalkin ja sisällön välillä, theme.spacing.l)
// + 1206 (vasen pääsisältö, flex: 1 — dynaaminen, kapenee pienemmillä näytöillä)
// + 25  (gap palstojen välissä, theme.spacing.l)
// + 400 (oikea palsta, kiinteä leveys)
// + 24  (sisältöalueen oikea padding)
// = 1920

export const SIDE_NAV_WIDTH = "13rem"; // 208px
export const SIDE_NAV_WIDTH_PIXELS = 208;
export const PAGE_MAX_WIDTH = "105rem"; // 1680px
export const RIGHT_PANEL_WIDTH = "25rem"; // 400px
